import { render, staticRenderFns } from "./CourseCategories.vue?vue&type=template&id=f888f688"
import script from "./CourseCategories.vue?vue&type=script&lang=js"
export * from "./CourseCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports